import axios from 'axios'
import { Message } from 'element-ui'
import i18n from '@/i18n'
// 超时时间
axios.defaults.timeout = 60000

// http请求拦截器
axios.interceptors.request.use(config => {
  if (!config.params) {
    config.params = {}
  }
  config.params.lang = i18n.locale || 'zh-CN'
  return config
}, error => {
  setTimeout(() => {
    Message({ showClose: true, message: 'server error', type: 'error' })
  }, 5000)
  return Promise.reject(error)
})

// http响应拦截器
axios.interceptors.response.use(data => {
  return data
}, error => {
  setTimeout(() => {
    // Message({ showClose: true, message: 'server error', type: 'error' })
  }, 1000)
  return Promise.reject(error)
})

export default axios
